// src/modules/app-views/products/pages/Init/components/tableColumns/stockColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function stockColumn(buildColumnProps, options = {}) {
  const {
    key = 'stock',
    title = 'stock',
    dataIndex = ['stock', 'quantity'],
    width = 100,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps('stock.quantity', columnProps),
    render: (_, r) => {
      const qty = r?.stock?.quantity;
      const minLevel = r?.stock?.minLevel;
      if (qty === undefined || qty === null) return '—';

      let color = 'default';
      if (minLevel && qty <= minLevel) {
        color = 'error';
      } else if (minLevel && qty <= minLevel * 1.5) {
        color = 'warning';
      }

      return <Tag color={color}>{qty}</Tag>;
    },
  };
}

export default stockColumn;
